import React, { lazy } from 'react';

// Lazy-loaded page components (code-split per page)
const CashinPage = lazy(() => import('./pages/cashin/CashinPage'));
const Cashout = lazy(() => import('./pages/cashout/Cashout'));
const ReportsTransactions = lazy(() => import('./pages/reports/ReportsTransactions'));
const RemittancePaymentPage = lazy(() => import('./pages/remittance/RemittancePaymentPage'));
const RemittanceReportPage = lazy(() => import('./pages/reports/RemittanceReportPage'));

/**
 * Cashier feature permission-to-component map.
 * Keys match the `name` field from backend permissions.
 */
export const cashierPages = (_displayName: string): Record<string, React.ReactNode> => ({
  cashin: <CashinPage />,
  cashout: <Cashout />,
  cashFlowStatement: <ReportsTransactions />,
  remittancesPayment: <RemittancePaymentPage />,
  remittancesReport: <RemittanceReportPage />,
});
